"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var returnAutocompleteOptions = function returnAutocompleteOptions(options, value, optionDisplayFieldKeys) {
  var optionsTypeObject = options[0] && typeof options[0] !== 'string';
  return options.filter(function (opt) {
    var _a, _b;

    var userValue = ("" + value).toLowerCase().trim();

    if (optionsTypeObject) {
      var primary = optionDisplayFieldKeys === null || optionDisplayFieldKeys === void 0 ? void 0 : optionDisplayFieldKeys.primary;
      var secondary = optionDisplayFieldKeys === null || optionDisplayFieldKeys === void 0 ? void 0 : optionDisplayFieldKeys.secondary;
      var optPrimary = primary && ("" + opt[primary]).toLowerCase();
      var optSecondary = secondary && ("" + opt[secondary]).toLowerCase();
      var valuePattern = new RegExp(userValue, 'g');
      return ((_a = "" + optPrimary) === null || _a === void 0 ? void 0 : _a.match(valuePattern)) || ((_b = "" + optSecondary) === null || _b === void 0 ? void 0 : _b.match(valuePattern));
    }

    return ("" + opt).toLowerCase().includes(userValue);
  });
};

exports.default = returnAutocompleteOptions;